<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>框架眼镜销售</el-breadcrumb-item>
      <el-breadcrumb-item>预付款管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="门店名称" min-width="15%"></el-table-column>
          <el-table-column prop="TotalPrepaymentIn" label="预付款入账总额" min-width="12%"></el-table-column>
          <el-table-column prop="TotalPrepaymentOut" label="预付款支出总额" min-width="12%"></el-table-column>
          <el-table-column prop="TotalPrepaymentLeft" label="预付款剩余金额" min-width="12%"></el-table-column>
          <el-table-column label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goOptometristYuFuKuanIn(scope.row)">预付款入账明细</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goOptometristYuFuKuanOut(scope.row)">预付款支出明细</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加预付款">
        <el-form :model="addForm" ref="addFormRef" label-width="75px">
          <el-form-item label="选择门店" class="addAdminForm">
            <Rsljigou :propsjigouid="addForm.jigouid" :propsjigouname="addForm.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="预付款" class="addAdminForm">
            <el-input v-model="addForm.prepayment" placeholder="请输入预付款"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="预付款入账明细" name="three" disabled="disabled">
        <OptometristYuFuKuanIn ref="SubVuethree" v-on:triggerFunc="BackToFirst"></OptometristYuFuKuanIn>
      </el-tab-pane>

      <el-tab-pane label="预付款支出明细" name="four" disabled="disabled">
        <OptometristYuFuKuanOut ref="SubVuefour" v-on:triggerFunc="BackToFirst"></OptometristYuFuKuanOut>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import OptometristYuFuKuanIn from '@/componentsSubVue/OptometristYuFuKuanIn.vue'
import OptometristYuFuKuanOut from '@/componentsSubVue/OptometristYuFuKuanOut.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    OptometristYuFuKuanIn,
    OptometristYuFuKuanOut
  },
  name: 'MyOptometristYuFuKuan',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询
      keywords: {
        jigouid: '0',
        jigouname: ''
      },
      // 添加
      addForm: {
        jigouid: '0',
        jigouname: '',
        prepayment: '',
        remark: ''
      }
    }
  },
  mounted () {
    this.apiOptometristYuFuKuannum()
    this.apiOptometristYuFuKuanlist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
      this.addForm.jigouid = vid
      this.addForm.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiOptometristYuFuKuanlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiOptometristYuFuKuannum()
      this.apiOptometristYuFuKuanlist()
    },
    clickadd () {
      this.apiAddOptometristYuFuKuan()
    },
    goOptometristYuFuKuanIn (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { jigouid: row.Jigouid } })
    },
    goOptometristYuFuKuanOut (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ name: '', params: { jigouid: row.Jigouid } })
    },
    apiOptometristYuFuKuanlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_OptometristYuFuKuanlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiOptometristYuFuKuannum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_OptometristYuFuKuannum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddOptometristYuFuKuan: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addForm.jigouid,
        prepayment: that.addForm.prepayment,
        remark: that.addForm.remark
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddOptometristYuFuKuan, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiOptometristYuFuKuannum()
            that.apiOptometristYuFuKuanlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
